import React from 'react';
import UpdateEmailLayout from '../../components/update-email/UpdateEmailLayout';
import UpdateEmailComplete from '../../components/update-email/UpdateEmailComplete';

const UpdateEmailCompletePage = (props) => (
  <UpdateEmailLayout>
    <UpdateEmailComplete {...props} />
  </UpdateEmailLayout>
);

export default UpdateEmailCompletePage;
